import { useInfiniteQuery } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from '../constants';
import { useSubscriptionNotificationStore } from 'store';

export const useSubscriptionHistory = (
  pageParam?: number,
  itemPerPage?: number
) => {
  const setShowNotification = useSubscriptionNotificationStore(
    state => state.setShowNotification
  );

  return useInfiniteQuery(
    `${ServerStateKeysEnum.subscriptionHistory}`,
    ({ pageParam = 1 }) =>
      subscriptionService.getSubscriptionHistory(pageParam, itemPerPage),
    {
      getNextPageParam: (lastPage, pages) => {
        if (typeof lastPage.currentPageNumber === 'undefined') {
          return undefined;
        }

        if (lastPage.currentPageNumber === lastPage.totalPages) {
          return undefined;
        } else {
          return lastPage.currentPageNumber + 1;
        }
      },
      staleTime: Infinity,
      onSuccess: data => {
        const isSuspended = data?.pages?.some(page =>
          page.subscriptions.some(
            subscription => subscription.status === 'suspended'
          )
        );
        if (isSuspended) {
          setShowNotification(true);
        }
      },
    }
  );
};
